import React from 'react';

import StatusBox from '../src/Components/Global/StatusBar';
import MenuBar from '../src/Components/Global/Main_Menu';

import MyFooter from '../src/Components/Global/Footer';

import { useContext } from 'react';
import { ContextProvider, Context_Navigation, Context_Explore_Laws } from '../src/Data/ContextProvider';

import Select_Law from '../src/Components/Analysis/Select_Law';

import Law_Regulation_E_Main from '../src/Components/Legal_Topics/Folder_Regulation_E/LawPage_Regulation_E';

import Law_Remittance_Transfers_Reg_E_Main from '../src/Components/Legal_Topics/Folder_Remittance_Transfers_Regulation_E/LawPage_Remittance_Transfers_Regulation_E';


export default function Explore_Laws_Main() {


    return (
        <div>
            <head>
                {/* Global site tag (gtag.js) - Google Analytics */}
                <script async src="https://www.googletagmanager.com/gtag/js?id=G-T2JKLXV9T9"></script>
                <script>{injectGA()}

                </script>
            </head>
            
            <ContextProvider>
                <Explore_Laws />
            </ ContextProvider>

        </div>
    );
}

const injectGA = () => {
    if (typeof window == 'undefined') {
        return;
    }
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());

    gtag('config', 'G-T2JKLXV9T9');
};

function Explore_Laws() {
    const [Navigation_GVars, Update_Navigation_GVars] = useContext(Context_Navigation);
    const [Explore_Laws_GVars, Update_Explore_Laws_GVars] = useContext(Context_Explore_Laws);



    return (
        <div>
            <MyFooter />
            <MenuBar />
            <div className='page_Tracker'> >> Home >> Explore Relevant Laws </div>
            {Navigation_GVars.statusBox ? <> <StatusBox /> </> : <></>}

            {Navigation_GVars.GetLaws ? <> <Select_Law /> </> : <></>}

            {Navigation_GVars.Law_Regulation_E_Page ? <>  <Law_Regulation_E_Main /> <></></> : <></>}

            {Navigation_GVars.Law_Remittance_Transfers_Regulation_E_Page ? <>  <Law_Remittance_Transfers_Reg_E_Main /> <></></> : <></>}

            {(Navigation_GVars.statusBox && Navigation_GVars.GetLaws && Navigation_GVars.Law_Regulation_E_Page == false && !Navigation_GVars.Law_Remittance_Transfers_Regulation_E_Page) ? <> <WatingForSelection /> </> : <></>}
        </div >
    );
}

function WatingForSelection() {

    return (
        <>
            <div className='Explore_Laws_Bar'></div><div className='Explore_Laws_Bar_Slider'></div>
            <div className='Explore_Laws_WaitingSelection'>
                <div>Please select a topic from the drop-down above and learn more about laws, regulations, and operational guidelines in the industry.</div>
                <br></br>
                <br></br>

                <div> Waiting for your selection... </div>
            </div >
        </>
    );
}


